<script>

export default {

    name: 'RentOutEventHandler',

    props: [],

    data() {
        return {
            languageDropdownIsOpen: false,
        }
    },

    created() {

    },

    mounted() {

        //check if popup must be opened
        const popupDiv = document.querySelector('#bex-popup');

        if (popupDiv) {

            this.$nextTick(() => {
                setTimeout(() => {
                    this.Bus.emit('build-popup', {
                        'reference': 'bex',
                        'data': {
                            'url': popupDiv.dataset.url,
                        }
                    })
                }, 100);
            });
        }

        //FORM STUFF
        this.Bus.on('form-select-changed', (data) => {

            //account select

            if (data.name === 'account_type') {

                document.querySelectorAll('div[data-section="account-type"]').forEach(el => {
                    el.classList.add('hidden');
                });

                document.querySelector(`div[data-reference="account-section-${data.value}"]`).classList.remove('hidden');
            }

            if (data.name === 'account_type_mobile') {

                document.querySelectorAll('div[data-section="account-type"]').forEach(el => {
                    el.classList.add('hidden');
                });

                document.querySelector(`div[data-reference="account-section-${data.value}"]`).classList.remove('hidden');
            }
        });

        this.Bus.on('form-toggle-changed', (data) => {

            //account select

            if (data.name === 'account_type') {

                document.querySelectorAll('div[data-section="account-type"]').forEach(el => {
                    el.classList.add('hidden');
                });

                document.querySelector(`div[data-reference="account-section-${data.value}"]`).classList.remove('hidden');
            }

            if (data.name === 'account_type_mobile') {

                document.querySelectorAll('div[data-section="account-type"]').forEach(el => {
                    el.classList.add('hidden');
                });

                document.querySelector(`div[data-reference="account-section-${data.value}"]`).classList.remove('hidden');
            }

            //park data (private owner) visible

            if (data.name === 'on_holiday_park') {

                document.querySelector(`div[data-section="park-data-private-owner"]`).classList.add('hidden');

                if (data.value === 1) {
                    document.querySelector(`div[data-section="park-data-private-owner"]`).classList.remove('hidden');
                }

                //warning location
                if (document.querySelector('.geolocation-field').changed) {
                    document.querySelector('.geolocation-field').validate()
                }
            }

            //website toggle

            if (data.name === 'has_website') {

                document.querySelector(`div[data-section="website-url"]`).classList.add('hidden');

                if (data.value === 1) {
                    document.querySelector(`div[data-section="website-url"]`).classList.remove('hidden');
                }

                document.querySelector(`div[data-section="image-file"]`).classList.add('hidden');

                if (data.value === 0) {
                    document.querySelector(`div[data-section="image-file"]`).classList.remove('hidden');
                }
            }

            //images toggle

            if (data.name === 'has_images') {

                document.querySelector(`div[data-section="with-files"]`).classList.add('hidden');

                if (data.value === 1) {
                    document.querySelector(`div[data-section="with-files"]`).classList.remove('hidden');
                }

                document.querySelector(`div[data-section="without-files"]`).classList.add('hidden');

                if (data.value === 0) {
                    document.querySelector(`div[data-section="without-files"]`).classList.remove('hidden');
                }
            }
        });

        // PLACE SELECTION
        this.Bus.on('place-id-selected', (data) => {
            if (data.placeId) {
                this.fetchCheckDistance(data);
            }
        });

    },

    methods: {
        async fetchCheckDistance(data) {

            const url = '/rent-out-form/check-distance/' + data.placeId;

            try {
                const response = await fetch(url);
                const isWithinDistance = await response.json();

                const facilityServicesDiv = document.querySelector(`div[data-section="facility-services-${data.reference}"]`);
                facilityServicesDiv.classList.add('hidden');

                if (isWithinDistance) {
                    facilityServicesDiv.classList.remove('hidden');
                }

            } catch (error) {
                console.error('Error fetching distance:', error);
            }
        },
    },

    render() {}
}
</script>

